import React from 'react';
import { Empty } from 'antd';

export const EmptyData = () => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />